import {Injectable} from '@angular/core';
import {AbstractControl, UntypedFormControl} from '@angular/forms';
import {HttpHeaders} from '@angular/common/http';
import {LoggedUser} from '../../common/types/loggedUser';
import {LocalStorageService} from './localStorage';

@Injectable({
  providedIn: 'root'
})
export class HttpHandlingService {

  constructor(private localStorage: LocalStorageService) {
  }

  handleUserErrorOutput(fieldControl: UntypedFormControl): string {
    switch (true) {
      case fieldControl.hasError('required'): return 'You must enter a value';
      case fieldControl.hasError('userexists'): return 'User with selected login already exists';
      case fieldControl.hasError('emailexists'): return 'User with selected email already exists';
      case fieldControl.hasError('passwordsdonotmatch'): return 'Passwords do not match';
      case fieldControl.hasError('unauthorized'): return 'Bad login credentials';
      case fieldControl.hasError('wrongloginpattern'): return 'Wrong pattern, use valid one-word login';
      case fieldControl.hasError('wrongsize50'): return 'Maximum size is 50 characters';
      case fieldControl.hasError('wrongsize60'): return 'Maximum size is 60 characters';
      case fieldControl.hasError('wrongsize254'): return 'Maximum size is 254 characters';
      case fieldControl.invalid: return 'Invalid email address';
      default: break;
    }
  }

  handleUserErrorOutputAbstract(fieldControl: AbstractControl): string {
    switch (true) {
      case fieldControl.hasError('required'): return 'You must enter a value';
      case fieldControl.hasError('userexists'): return 'User with selected login already exists';
      case fieldControl.hasError('emailexists'): return 'User with selected email already exists';
      case fieldControl.hasError('passwordsdonotmatch'): return 'Passwords do not match';
      case fieldControl.hasError('unauthorized'): return 'Bad login credentials';
      case fieldControl.invalid: return 'Invalid email address';
      default: break;
    }
  }

  authorizationHeaders(): HttpHeaders {
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    if (this.localStorage.get('loggedUser') !== null) {
      const loggedUser = this.localStorage.get('loggedUser') as LoggedUser;
      headers = headers.append('Authorization', 'Bearer ' +  loggedUser.token);
    }
    return headers;
  }

  downloadFileHeaders(): HttpHeaders {
    let headers = new HttpHeaders({'Content-Type': 'application/octet-stream'});
    if (this.localStorage.get('loggedUser') !== null) {
      const loggedUser = this.localStorage.get('loggedUser') as LoggedUser;
      headers = headers.append('Authorization', 'Bearer ' +  loggedUser.token);
    }
    return headers;
  }

  simpleHeader(): HttpHeaders {
    return new HttpHeaders({'Content-Type': 'application/json'});
  }

  isUserLoggedIn(): boolean {
    return this.localStorage.get('loggedUser') !== null;
  }

  logout(): void {
    this.localStorage.remove('loggedUser');
    window.location.reload();
  }
}
